import React from "react";

import {
  FaPlus,
  FaTimes,
} from "react-icons/fa";

import AddCajaForm from "./AddCajaForm";

const AddCaja = ({
  show,
  setShow,
}) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="caja2-add-row">
        <button
          type="button"
          className={
            show
              ? "caja2-add-button caja2-add-button-cancel"
              : "caja2-add-button"
          }
          onClick={handleShow}
        >
          {show ? (
            <>
              <FaTimes />
              Cancelar
            </>
          ) : (
            <>
              <FaPlus />
              Nueva caja
            </>
          )}
        </button>
      </div>

      {show && (
        <div className="caja2-add-form">
          <AddCajaForm
            setShow={setShow}
          />
        </div>
      )}
    </>
  );
};

export default AddCaja;